/**
 * MEMBERSHIP CONSTANTS
 * 
 * Configurações estáticas para o módulo de Planos (Membership).
 * Membership = template do plano. MemberMembership = contrato do cliente.
 */



export const MEMBERSHIP_TYPES = [
    { value: 'recurrent', label: 'Mensalidade Recorrente' },
    { value: 'fixed', label: 'Plano Fechado / Fixo' },
    { value: 'pass', label: 'Pacote de Aulas (Pass)' }
];

export const DURATION_TYPES = [
    { value: 'monthly', label: 'Meses' },
    { value: 'yearly', label: 'Anos' },
    { value: 'days', label: 'Dias' },
    { value: 'classes', label: 'Aulas' }
];

